// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:16
import { IsochroneResult_abstract } from './../abstract/SagaBase/IsochroneResult_abstract';
export class IsochroneResult extends IsochroneResult_abstract {}
